import React from 'react'

import { Item } from '../../../components/Containers/Main/Item'
import HomePageDescription from '../../../components/HomePageDescription'
import { GamesBlockWithData as GamesBlock } from '../../../containers/GamesBlock'
import JackpotBox from '../../../containers/JackpotBox/Loadable'
import LastWinsWidgetBox from '../../../containers/LastWinsWidgetBox/Loadable'
import TournamentsWidgetBox from '../../../containers/TournamentsWidgetBox/LoadableTournamentsWidgetBox'
import HomeBannerBox from './HomeBannerBox'
import { Container } from './styles/Container'

function HomePage() {
  return (
    <Container>
      <HomeBannerBox />
      <Item>
        <Container style={{ flex: 1, overflow: 'hidden' }}>
          <JackpotBox />
          <GamesBlock />
        </Container>
        <Container>
          <TournamentsWidgetBox />
          <LastWinsWidgetBox />
        </Container>
      </Item>
      <HomePageDescription />
    </Container>
  )
}

export default HomePage
